export class AppRoutes {

  static publicRoutes() {
    return [
      AppRoutes.Login,
      AppRoutes.Login2fa,
      AppRoutes.LoginRecovery,
      AppRoutes.Register,
      AppRoutes.ForgotPassword,
      AppRoutes.ResetPassword,
      AppRoutes.Lockout,
      AppRoutes.ResendEmailConfirmation
    ];
  }

  static readonly Home = '/';
  static readonly AppSettings = '/config';
  static readonly WorkQueue = '/WorkQueue';
  static readonly Kit = '/kit';

  // Development routes
  static readonly DevIndex = '/dev';

  // Authentication routes
  static readonly Login = '/account/login';
  static readonly Login2fa = '/account/login-2fa';
  static readonly LoginRecovery = '/account/login-recovery';
  static readonly Register = '/account/register';
  static readonly ForgotPassword = '/account/forgot-password';
  static readonly ResetPassword = '/account/reset-password';
  static readonly Lockout = '/account/lockout';
  static readonly ResendEmailConfirmation = '/account/resend-email-confirmation';

  // Account management routes
  static readonly ManageProfile = '/account/manage';
  static readonly ManageEmail = '/account/manage/email';
  static readonly ManageChangePassword = '/account/manage/change-password';
  static readonly ManageTwoFactor = '/account/manage/two-factor';
  static readonly ManageEnableAuthenticator = '/account/manage/enable-authenticator';
  static readonly ManageGenerateRecoveryCodes = '/account/manage/generate-recovery-codes';
  static readonly ManagePersonalData = '/account/manage/personal-data';

  static readonly Populations = '/population';
  static readonly PopulationUpload = '/population/upload';
  static readonly PopulationCreateLocal = '/population/create-local';
  static readonly PopulationEdit = '/population/:populationId/edit';
  static readonly PopulationDetail = '/population/:populationId/detail';

  static readonly Case = '/case';
  static readonly CaseCreate = '/case/Create';
  static readonly CaseDetails = '/lab/:labId/case/:caseId';
  static readonly CaseEdit = '/lab/:labId/case/:caseId/edit';
  static readonly CaseRunCreate = '/lab/:labId/case/:caseId/run/create/:runType'
  static readonly CaseRunCreateWithLabSelect = '/profiles/searches/:runType/create'
  static readonly CaseRunPrint = '/lab/:labId/case/:caseId/run/:caseRunId/results/print'
  static readonly CaseRunDetails = '/lab/:labId/case/:caseId/run/:caseRunId'
  static readonly CaseRunDetailsResults = '/lab/:labId/case/:caseId/run/:caseRunId/results'
  static readonly CaseRunCalculate = '/lab/:labId/case/:caseId/run/:caseRunId/calculate/:runType'
  static readonly CaseRunCalculationDetails = '/lab/:labId/case/:caseId/run/:caseRunId/calculations/:calculationId/detail'
  // static readonly CaseRunCalculationDetailsFromResults = '/lab/:labId/case/:caseId/run/:caseRunId/results/calculations/:calculationId/detail/:urlb64'

  static readonly CaseRunClone = '/lab/:labId/case/:caseId/run/clone/:oldRunId/:runType'

  static readonly Lab = '/lab';
  static readonly LabCreate = '/lab/create';
  static readonly LabEdit = '/lab/:labId/edit';
  static readonly LabDetails = '/lab/:labId/detail';

  static readonly User = '/user';
  static readonly UserCreate = '/user/create';
  static readonly UserEdit = '/user/:userId/edit';
  static readonly UserDetails = '/user/:userId';

  // static readonly EvidenceIndex = '/lab/:labId/case/:caseId/run/:caseRunId/evidence';
  static readonly EvidenceUpload = '/lab/:labId/case/:caseId/evidence/upload';
  static readonly EvidenceDetails = '/lab/:labId/case/:caseId/evidence/:evidenceId/detail';
  static readonly EvidenceCreateCopy = '/lab/:labId/case/:caseId/evidence/:evidenceId/create-copy';
  static readonly EvidenceEdit = '/lab/:labId/case/:caseId/evidence/:evidenceId/edit';
  static readonly EvidenceImport = '/lab/:labId/case/:caseId/evidence/import';


  static readonly SampleDetails = '/lab/:labId/case/:caseId/sample/:sampleId/detail';
  static readonly SampleEdit = '/lab/:labId/case/:caseId/sample/:sampleId/edit';
  static readonly SampleCreateCopy = '/lab/:labId/case/:caseId/sample/:sampleId/create-copy';
  static readonly SampleUpload = '/lab/:labId/case/:caseId/sample/upload';
  static readonly SampleImport = '/lab/:labId/case/:caseId/sample/import';
  static readonly SampleKeyboardUpload = '/lab/:labId/case/:caseId/sample/keyboard-upload';
  static readonly SampleCalcRMP = '/lab/:labId/case/:caseId/sample/:sampleId/calc-rmp';

  static readonly SampleDetailsWithoutCase = '/lab/:labId/sample/:sampleId/detail';
  static readonly SampleEditWithoutCase = '/lab/:labId/sample/:sampleId/edit';
  static readonly SampleCreateCopyWithoutCase = '/lab/:labId/sample/:sampleId/create-copy';
  // static readonly SampleUploadWithoutCase = '/lab/:labId/sample/upload';
  // static readonly SampleImport = '/lab/:labId/case/:caseId/sample/import';
  // static readonly SampleKeyboardUpload = '/lab/:labId/case/:caseId/sample/keyboard-upload';
  static readonly SampleCalcRMPWithoutCase = '/lab/:labId/sample/:sampleId/calc-rmp';


  static readonly CaseCustomPanelUpload = '/lab/:labId/case/:caseId/custom-panel/upload';
  static readonly CaseCustomPanelEdit = '/lab/:labId/case/:caseId/custom-panel/:panelId/edit';

  static readonly Profiles = '/profiles';
  static readonly ProfilesSampleEdit = '/profiles/lab/:labId/samples/:sampleId/edit';

  static readonly ProfilesSampleUpload = '/profiles/lab/samples/upload';
  static readonly ProfilesSampleCalcRMP = '/profiles/lab/samples/{:sampleId}/rmp';
  static readonly ProfilesEvidenceUpload = '/profiles/lab/evidence/upload';

  static readonly ProfilesMetadata = '/enrollments';
  static readonly ProfilesMetadataCreate = '/enrollments/create';
  static readonly ProfilesMetadataEdit = '/enrollments/:metaId/edit';
  static readonly ProfilesMetadataSearch = '/enrollments/search';


  static readonly ProfilesMetadataEditBio = '/enrollments/:metaId/edit';
  static readonly ProfilesMetadataEditPhysical = '/enrollments/:metaId/edit/physical';
  static readonly ProfilesMetadataEditContact = '/enrollments/:metaId/edit/contact';
  static readonly ProfilesMetadataEditAdditional = '/enrollments/:metaId/edit/additional';
  static readonly ProfilesMetadataEditEmployment = '/enrollments/:metaId/edit/employment';
  static readonly ProfilesMetadataEditIdentification = '/enrollments/:metaId/edit/identification';

  static readonly ProfilesMetadataCreateBio = '/enrollments/create';
  static readonly ProfilesMetadataCreatePhysical = '/enrollments/create/physical';
  static readonly ProfilesMetadataCreateContact = '/enrollments/create/contact';
  static readonly ProfilesMetadataCreateAdditional = '/enrollments/create/additional';
  static readonly ProfilesMetadataCreateEmployment = '/enrollments/create/employment';
  static readonly ProfilesMetadataCreateIdentification = '/enrollments/create/identification';



  static readonly Roles = '/roles';


}



// https://dev.to/0916dhkim/type-safe-usage-of-react-router-5c44
const PATHS = [
  AppRoutes.Home,
  AppRoutes.WorkQueue,
  AppRoutes.Case,
  AppRoutes.CaseCreate,
  AppRoutes.CaseDetails,
  AppRoutes.CaseRunCreate,
  AppRoutes.CaseRunCreateWithLabSelect,

  // Authentication paths
  AppRoutes.Login,
  AppRoutes.Login2fa,
  AppRoutes.LoginRecovery,
  AppRoutes.Register,
  AppRoutes.ForgotPassword,
  AppRoutes.ResetPassword,
  AppRoutes.Lockout,
  AppRoutes.ResendEmailConfirmation,

  // Account management paths
  AppRoutes.ManageProfile,
  AppRoutes.ManageEmail,
  AppRoutes.ManageChangePassword,
  AppRoutes.ManageTwoFactor,
  AppRoutes.ManageEnableAuthenticator,
  AppRoutes.ManageGenerateRecoveryCodes,
  AppRoutes.ManagePersonalData,

  AppRoutes.CaseRunPrint,
  AppRoutes.CaseRunDetails,
  AppRoutes.CaseRunCalculate,
  AppRoutes.CaseRunClone,
  AppRoutes.CaseRunDetailsResults,
  AppRoutes.CaseRunCalculationDetails,
  AppRoutes.CaseEdit,
  AppRoutes.Kit,
  AppRoutes.Lab,
  AppRoutes.LabCreate,
  AppRoutes.LabEdit,
  AppRoutes.LabDetails,

  AppRoutes.PopulationUpload,
  AppRoutes.PopulationDetail,
  AppRoutes.PopulationEdit,
  AppRoutes.Populations,
  AppRoutes.PopulationCreateLocal,

  AppRoutes.EvidenceCreateCopy,
  AppRoutes.EvidenceDetails,
  AppRoutes.EvidenceEdit,
  AppRoutes.EvidenceUpload,
  AppRoutes.EvidenceImport,

  AppRoutes.SampleEdit,
  AppRoutes.SampleUpload,
  AppRoutes.SampleKeyboardUpload,
  AppRoutes.SampleDetails,
  AppRoutes.SampleCreateCopy,
  AppRoutes.SampleImport,
  AppRoutes.SampleCalcRMP,

  AppRoutes.SampleDetailsWithoutCase,
  AppRoutes.SampleCalcRMPWithoutCase,
  AppRoutes.SampleEditWithoutCase,
  AppRoutes.SampleCreateCopyWithoutCase,
  // AppRoutes.SampleUploadWithoutCase,

  AppRoutes.CaseCustomPanelUpload,
  AppRoutes.CaseCustomPanelEdit,
  AppRoutes.AppSettings,

  AppRoutes.Profiles,
  AppRoutes.ProfilesSampleEdit,
  AppRoutes.ProfilesSampleUpload,
  AppRoutes.ProfilesSampleCalcRMP,

  AppRoutes.ProfilesMetadataEdit,
  AppRoutes.ProfilesMetadataEditBio,
  AppRoutes.ProfilesMetadataEditPhysical,
  AppRoutes.ProfilesMetadataEditContact,
  AppRoutes.ProfilesMetadataEditAdditional,
  AppRoutes.ProfilesMetadataEditEmployment,
  AppRoutes.ProfilesMetadataEditIdentification,

  AppRoutes.ProfilesMetadataCreate,
  AppRoutes.ProfilesMetadataCreateBio,
  AppRoutes.ProfilesMetadataCreatePhysical,
  AppRoutes.ProfilesMetadataCreateContact,
  AppRoutes.ProfilesMetadataCreateAdditional,
  AppRoutes.ProfilesMetadataCreateEmployment,
  AppRoutes.ProfilesMetadataCreateIdentification,

  AppRoutes.ProfilesMetadata,
  AppRoutes.ProfilesMetadataSearch,

  AppRoutes.ProfilesEvidenceUpload,

  AppRoutes.User,
  AppRoutes.UserCreate,
  AppRoutes.UserEdit,
  AppRoutes.UserDetails,

  AppRoutes.Roles,

  AppRoutes.DevIndex
] as const;

type ExtractRouteParams<T> = string extends T
  ? Record<string, any>
  : T extends `${infer _Start}:${infer Param}/${infer Rest}`
  ? { [k in Param | keyof ExtractRouteParams<Rest>]: any }
  : T extends `${infer _Start}:${infer Param}`
  ? { [k in Param]: any }
  : {};

export type Path = (typeof PATHS)[number];

// Object which has matching parameter keys for a path.
export type PathParams<P extends Path> = ExtractRouteParams<P>;

/**
 * Build an url with a path and its parameters.
 * Path parameters are replaced in the URL, additional parameters are added as query string.
 * @example
 * buildUrl(
 *   '/a/:first/:last',
 *   { first: 'p', last: 'q', extra: 'value', other: 'param' },
 * ) // returns '/a/p/q?extra=value&other=param'
 * @param path target path.
 * @param params parameters (both path params and query params).
 */
export const buildUrl = <P extends Path>(
  path: P,
  params: PathParams<P> & Record<string, any>,
): string => {
  let ret: string = path;
  const queryParams: Record<string, string> = {};

  // Upcast `params` to be used in string replacement.
  const paramObj: { [i: string]: string } = params;

  // Extract path parameters (those that exist in the path as :param)
  const pathParamKeys = new Set<string>();
  const pathParamMatches = path.match(/:(\w+)/g);
  if (pathParamMatches) {
    pathParamMatches.forEach(match => {
      const paramName = match.substring(1); // Remove the ':' prefix
      pathParamKeys.add(paramName);
    });
  }

  // Process all parameters
  for (const key of Object.keys(paramObj)) {
    if (pathParamKeys.has(key)) {
      // This is a path parameter - replace it in the URL
      ret = ret.replace(`:${key}`, paramObj[key]);
    } else {
      // This is an additional parameter - add to query string
      queryParams[key] = paramObj[key];
    }
  }

  // Build query string if there are query parameters
  const queryKeys = Object.keys(queryParams);
  if (queryKeys.length > 0) {
    const queryString = queryKeys
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join('&');
    ret += `?${queryString}`;
  }

  return ret;
};